import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const DriverPerformanceMonitoringPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  transportManagerContact,
  safetyOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Driver_Performance_Monitoring_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Driver Performance Monitoring Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        This policy establishes the framework for monitoring and managing the performance of drivers to ensure safety, compliance, and continual improvement. The company aims to promote responsible driving behaviour, reduce risk, and enhance operational efficiency.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all drivers employed or contracted by {clientName || "the Company"} who operate vehicles on behalf of the business.
      </p>

      <h4 className="section-title">3. Responsibilities</h4>
      <p className="section-content"><strong>Drivers:</strong> Expected to comply with all traffic laws, company policies, and safe driving standards. Participate actively in performance monitoring processes.</p>
      <p className="section-content"><strong>Transport Managers:</strong> Responsible for overseeing driver performance monitoring, analysing data, and implementing improvement measures.</p>
      <p className="section-content"><strong>Safety Officers:</strong> Assist with monitoring, training, and investigating incidents related to driver performance.</p>

      <h4 className="section-title">4. Monitoring Methods</h4>
      <ul>
        <li>Use of telematics and GPS systems to track vehicle speed, braking, acceleration, and route adherence.</li>
        <li>Regular review of tachograph data to ensure compliance with drivers’ hours regulations.</li>
        <li>Performance reviews based on delivery punctuality, fuel efficiency, and customer feedback.</li>
        <li>Observation and feedback from supervisors and colleagues.</li>
      </ul>

      <h4 className="section-title">5. Data Privacy and Compliance</h4>
      <p className="section-content">
        All driver monitoring data will be collected and processed in accordance with applicable data protection laws, including GDPR. Data will only be used for legitimate business purposes and handled confidentially.
      </p>

      <h4 className="section-title">6. Performance Review and Feedback</h4>
      <p className="section-content">
        Drivers will receive regular feedback and reviews, including:
      </p>
      <ul>
        <li>One-to-one meetings to discuss performance metrics and areas for improvement.</li>
        <li>Training and coaching sessions where necessary.</li>
        <li>Setting clear performance objectives and targets.</li>
      </ul>

      <h4 className="section-title">7. Managing Poor Performance</h4>
      <p className="section-content">
        Instances of poor performance will be addressed promptly following the company’s disciplinary procedures, including:
      </p>
      <ul>
        <li>Identification and documentation of issues.</li>
        <li>Opportunity for driver to respond and improve.</li>
        <li>Implementation of corrective actions such as retraining or closer supervision.</li>
        <li>Formal disciplinary action if performance does not improve.</li>
      </ul>

      <h4 className="section-title">8. Recognition and Reward</h4>
      <p className="section-content">
        The company values and recognises excellent driver performance through formal reward programs, incentives, and public acknowledgement.
      </p>

      <h4 className="section-title">9. Record Keeping</h4>
      <p className="section-content">
        All monitoring records, performance reviews, and related documentation will be securely stored and retained in line with company policy and legal requirements.
      </p>

      <h4 className="section-title">10. Contact Information</h4>
      <ul>
        <li><strong>Transport Manager:</strong> {transportManagerContact || "[Insert Contact Number]"}</li>
        <li><strong>Safety Officer:</strong> {safetyOfficerContact || "[Insert Contact Number]"}</li>
      </ul>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read and understood the Driver Performance Monitoring Policy and agree to comply with its requirements.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is hereby in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default DriverPerformanceMonitoringPolicy;
